var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// @ts-ignore
import { getLocalVideoTrack } from '../base/tracks';
// @ts-ignore
import { NOTIFICATION_TIMEOUT_TYPE, showErrorNotification } from '../notifications';
// @ts-ignore
import { createEffect } from '../stream-effects/virtual-background';
import { SET_FACE_RECOGNITION_ENABLED } from '../face-recognition/actionTypes';
import logger from '../face-recognition/logger';
/**
 * Updates the noise suppression active state.
 *
 * @param {boolean} enabled - Is noise suppression enabled.
 * @returns {{
 *      type: SET_FACE_RECOGNITION_ENABLED,
 *      enabled: boolean
 * }}
 */
export function setFaceRecognitionEnabledState(enabled) {
    return {
        type: SET_FACE_RECOGNITION_ENABLED,
        enabled
    };
}
/**
 * Attempt to enable or disable noise suppression using the {@link NoiseSuppressionEffect}.
 *
 * @param {boolean} enabled - Enable or disable noise suppression.
 *
 * @returns {Function}
 */
export function setFaceRecognitionEnabled(options, jitsiTrack) {
    return (dispatch, getState) => __awaiter(this, void 0, void 0, function* () {
        const state = getState();
        // const localAudio = getLocalJitsiAudioTrack(state);
        const currentLocalTrack = getLocalVideoTrack(state['features/base/tracks']);
        logger.info(`Attempting to set face recognition enabled state: ${options.enabled}`);
        //Below added two  extra else if statement to manage Face Registration dialog state
        try {
            if (options.enabled === true) {
                yield jitsiTrack.setEffect(yield createEffect({ enabled: true }, dispatch));
                logger.info('Face recognition enabled on the Dialog');
            }
            else if (options.enabled === false) {
                yield jitsiTrack.setEffect(yield createEffect({ enabled: false }, dispatch));
                logger.info('Face recognition disabled on the Dialog');
            }
            else {
                logger.warn(`Face recognition enabled state already: ${options.enabled}`);
            }
        }
        catch (error) {
            logger.error(`Failed to set face recognition enabled to: ${options.enabled}`, error);
            dispatch(showErrorNotification({
                titleKey: 'notify.faceRecognitionFailedTitle'
            }, NOTIFICATION_TIMEOUT_TYPE.MEDIUM));
        }
    });
}
